<div class="basic-card" (click)="onAddPersonalityClick()" [matTooltip]="'Add new personality'">
  <div class="horizontal">
    <span nz-icon style="font-size: 25px" class="material-symbols-rounded">add</span>
  </div>
</div>

<app-new-edit-personality [(isNewEditVisible)]="isNewEditVisible"></app-new-edit-personality>
